import { Stack } from '@mui/material';
import clsx from 'clsx';
import moment from 'moment';
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

import Text from 'commons/Text';
import LogoPlatForm from 'images/logo-platform.svg';

import useStyles from './styles';

const CertificateHeader = ({ certificate }) => {
  const { t, i18n } = useTranslation();
  const classes = useStyles();

  const { id, legal_name } = certificate?.issued_by || {};

  const time = moment(certificate?.created_at);
  const day = time.format('DD');
  const month = time.format('MMMM');
  const year = time.format('YYYY');

  const timeDay =
    i18n?.language === 'vi'
      ? `${day} tháng ${time.format('MM')} năm ${year}`
      : `${month} ${day}, ${year}`;

  return (
    <>
      <Stack
        direction="row"
        sx={{ justifyContent: 'space-between', alignItems: 'flex-start' }}
      >
        <div>
          <Text className={classes.textHeading}>{t('certificate_authenticity')}</Text>
          <Text className={classes.textHeadingTwo}>{t('of_original_artwork')}</Text>
        </div>

        <div>
          <Text
            className={classes.textGenerated}
            mb={5}
          >
            {t('generated_by')}
          </Text>
          <img
            src={LogoPlatForm}
            className={classes.logoPlatform}
          />
        </div>
      </Stack>

      <Text
        type="2xs"
        className={classes.textCertificateNumber}
        mt={8}
      >
        {t('certificate_number')} | {certificate?.id}
      </Text>

      <Text
        type="2xs"
        className={classes.textCertificateNumber}
        mt={8}
      >
        {t('issue_date')} | {time?.format('DD.MM.YYYY')}
      </Text>

      <Text
        title
        type="3xl"
        className={classes.textNameArtist}
      >
        {legal_name}
      </Text>

      <Text
        mt={8}
        className={clsx(classes.subText, {
          [classes.hideText]: !id,
        })}
        type="2xs"
      >
        {`${t('account_id')} | ${id}`}
      </Text>

      <Text
        mt={24}
        className={classes.textDescription}
      >
        <Trans
          i18nKey="text_certificate_authenticity"
          values={{ name: legal_name, timeDay }}
        />
      </Text>
    </>
  );
};

export default CertificateHeader;
